export interface ParsedFile {
  path: string;
  filename: string;
}

export interface FileUploaderProps {
  onFileParsed?: (file: ParsedFile) => void;
  onError?: (error: Error) => void;
  accept?: string;
}

export const toBase64 = (file: File): Promise<ParsedFile> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>
      resolve({
        path: reader.result as string,
        filename: file.name,
      });
    reader.onerror = error => reject(error);
  });
